import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { catalogGet, catalogKnmTypes248Get } from 'CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import {
  createKnmFilter,
  deleteKnmFilter,
  fetchKnmFilterById,
  fetchKnmFilters,
  updateKnmFilter,
} from 'APIPackage/KnmListModule/services/knmListApi';
import {
  geCatalogsResponsibilityTypesSelectOptions,
  getCatalogKnmStatuses248SelectOptions,
  getCatalogKnmSubjectTypesSelectOptions,
  getCatalogKnmTypes248SelectOptionsSelector,
  getCatalogKnmTypes294SelectOptions,
  getCatalogKnoAdminLevelsSelectOptions,
  getCatalogsChecklistFullnessTypesSelectOptions,
  getCatalogsMspCategoriesSelectOptions,
  getCatalogsRegisterTypesSelectOptions,
  getCatalogsSupervisionTypesSelectOptions,
  getCatalogsTerritorialUnitsSelectOptions,
  getFederalLaw248SelectOptions,
  getUserKnoSelectOptions,
  getUserProsecutorSelectOptions,
} from 'CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { ITerritorialUnitSelectOption } from 'CorePackage/CatalogsModule/interfaces/ITerritorialUnitSelectOption';
import {
  getDictionariesKnmSubjectTypesSelectOptions,
  getDictionariesKnoOrganizationsSelectOptions,
  makeGetDictionariesKnmKindsSelectOptions,
  makeGetDictionariesSupervisionTypesExtendedSelectOptions,
} from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { noKnoOrganizationAdminLevelSelectOption } from 'KnmListPackage/KnmListPanelModule/constants/knmListFilterOptions';
import { IKnoAdminLevelSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnoAdminLevelSelectOption';
import { IChecklistFullnessTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IChecklistFullnessTypeSelectOption';
import { IFederalLawSelectOption } from 'CorePackage/CatalogsModule/interfaces/IFederalLawSelectOption';
import { ISupervisionTypeSelectOption } from 'CorePackage/CatalogsModule/hooks/useKnmSupervisionTypes';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { IKnmTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { IDictionaryKnoOrganizationSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { IKnmSubjectTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmSubjectTypeSelectOption';
import { IKnmKind } from 'APIPackage/DictionariesModule/interfaces/IKnmKind';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IRegisterTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IRegistryTypeSelectOption';
import { IKnmStatusSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmStatusSelectOption';
import { IMspCategorySelectOption } from 'CorePackage/CatalogsModule/interfaces/IMspCategorySelectOption';
import { getStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';
import { IKnmListFilterRaw } from 'APIPackage/KnmListModule/interfaces/IKnmListFilterRaw';
import {
  getKnmDataPlanId,
  getKnmErpStatusesSelectOptions,
  getKnmFederalLawsSelectOptions,
  getKnmIsTypeErknmPlanned,
  getKnmIsTypeErpPlanned,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import {
  dictionariesFederalLawsGet,
  dictionariesKnmKindsItemGet,
  dictionariesKnmSubjectTypesGet,
  dictionariesKnoOrganizationsItemGet,
  dictionariesSupervisionTypesItemGet,
} from 'CorePackage/DictionariesModule/actions/dictionariesActions';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { dictionariesSupervisionTypesItemGetHandlerWithReturnOptions } from 'CorePackage/DictionariesModule/sagas/dictionariesSaga';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';

import { KnmListFilterActionsEnum } from '../enums/KnmListFilterActionsEnum';
import {
  knmListFilterCreate,
  knmListFilterGetData,
  knmListFilterGetMeta,
  knmListFilterRemove,
  knmListFilterSetCurrent,
  knmListFilterSetCurrentControlOrganizations,
  knmListFilterSetCurrentFederalLaws,
  knmListFilterSetData,
  knmListFilterSetMeta,
  knmListFilterUpdate,
} from '../actions/knmListFilterActions';
import { mapRawToKnmFilter } from '../common/mapRawToKnmFilter';
import { mapKnmFilterToRaw } from '../common/mapKnmFilterToRaw';
import { convertFilterDataToControlOrganizationsIds } from '../common/convertFilterDataToControlOrganizationsIds';
import { IKnmListFilter } from '../interfaces/IKnmListFilter';
import {
  getKnmListCurrentControlOrganizations,
  getKnmListCurrentFederalLaws,
} from '../selectors/knmListFilterSelectors';
import { IResponsibilityTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IResponsibilityTypeSelectOption';
import { IKnmSubjectTypesERVK } from '../../../APIPackage/CatalogsModule/interfaces/IKnmSubjectTypesERVK';
import { IKnmSubjectTypeCommonSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmSubjectTypeCommonSelectOptions';

export function* watchKnmListFilterSaga() {
  yield takeEvery(KnmListFilterActionsEnum.KNM_LIST_FILTER_INIT, knmListFilterInitSaga);
  yield takeEvery(KnmListFilterActionsEnum.KNM_LIST_FILTER_GET_META, knmListFilterGetMetaSaga);
  yield takeEvery(KnmListFilterActionsEnum.KNM_LIST_FILTER_GET_DATA, knmListFilterGetDataSaga);
  yield takeEvery(KnmListFilterActionsEnum.KNM_LIST_FILTER_CREATE, knmListFilterCreateSaga);
  yield takeEvery(KnmListFilterActionsEnum.KNM_LIST_FILTER_UPDATE, knmListFilterUpdateSaga);
  yield takeEvery(KnmListFilterActionsEnum.KNM_LIST_FILTER_REMOVE, knmListFilterRemoveSaga);
  yield takeEvery(
    KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT_CONTROL_ORGANIZATIONS,
    knmListFilterSetCurrentControlOrganizationsSaga,
  );
  yield takeEvery(
    KnmListFilterActionsEnum.KNM_LIST_FILTER_SET_CURRENT_FEDERAL_LAWS,
    knmListFilterSetCurrentFederalLawsSaga,
  );
}

const knmListPageCatalogs: CommonCatalogsNamesEnum[] = [
  CommonCatalogsNamesEnum.KNM_YEARS,
  CommonCatalogsNamesEnum.TERRITORIAL_UNITS,
  CommonCatalogsNamesEnum.USER_KNOS,
  CommonCatalogsNamesEnum.SUPERVISION_TYPES,
  CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES,
  CommonCatalogsNamesEnum.REGISTER_TYPES,
  CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES,
  CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS,
  CommonCatalogsNamesEnum.MSP_CATEGORIES,
  CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES,
];

const knmListPageErknmCatalogs: CommonCatalogsNamesEnum[] = [
  CommonCatalogsNamesEnum.KNM_TYPES_CANCELED,
  CommonCatalogsNamesEnum.KNM_STATUSES_248,
  CommonCatalogsNamesEnum.FEDERAL_LAWS_248,
];
const knmListPageErpCatalogs: CommonCatalogsNamesEnum[] = [
  CommonCatalogsNamesEnum.KNM_TYPES_294,
  CommonCatalogsNamesEnum.KNM_STATUSES_294,
  CommonCatalogsNamesEnum.FEDERAL_LAWS_294,
];

function* knmListFilterInitSaga() {
  const state: IRootState = yield select();
  const isErknm = getLawInterface(state) === LawInterfacesEnum.FZ_248;

  yield all(knmListPageCatalogs.map(catalogName => put(catalogGet(catalogName))));
  yield put(dictionariesKnoOrganizationsItemGet());
  yield put(dictionariesKnmSubjectTypesGet());
  yield put(dictionariesFederalLawsGet());
  if (isErknm) {
    yield all(knmListPageErknmCatalogs.map(catalogName => put(catalogGet(catalogName))));
    yield put(dictionariesKnmKindsItemGet());
    yield put(catalogKnmTypes248Get({}));
    const controllingOrganizations = getKnmListCurrentControlOrganizations(state);

    if (controllingOrganizations.length) {
      yield put(dictionariesSupervisionTypesItemGet(controllingOrganizations, false));
    }
  } else {
    yield all(knmListPageErpCatalogs.map(catalogName => put(catalogGet(catalogName))));
  }
  yield put(knmListFilterGetMeta());
}

function* knmListFilterGetMetaSaga() {
  function* funcTry() {
    const lawInterface: LawInterfacesEnum = yield select(getLawInterface);
    const isErknm = lawInterface === LawInterfacesEnum.FZ_248;
    const meta: IFilterResult[] = yield fetchKnmFilters();

    yield put(knmListFilterSetMeta(meta));
    const current = getStorageItem<IKnmListFilter>(StorageNamesEnum.KNM_FILTER);

    if (isErknm && current?.controllingOrganizations) {
      const ids: string[] = current?.controllingOrganizations
        .map(item => (typeof item.value !== 'string' ? item.value.dictVersionId : ''))
        .filter(item => item);

      yield put(knmListFilterSetCurrentControlOrganizations(ids));
    }
    if (!isErknm && current?.federalLaws) {
      const currentFederalLaws = current.federalLaws as IFederalLawSelectOption[];

      const federalLawsErpSelectOptions: ReturnType<
        typeof getKnmFederalLawsSelectOptions
      > = yield select((state: IRootState) => getKnmFederalLawsSelectOptions(state, false));
      const allowedIds = new Set(federalLawsErpSelectOptions?.map(opt => opt.id));

      current.federalLaws = currentFederalLaws.filter(opt => allowedIds.has(opt.id));
    }
    const currentId = meta.find(m => m.name === current?.name)?.id;

    yield put(knmListFilterSetCurrent({ current, currentId }));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* knmListFilterGetDataSaga(action: ActionType<typeof knmListFilterGetData>) {
  function* funcTry() {
    const { id } = action.payload;
    const state: IRootState = yield select();
    const isErknm = getLawInterface(state) === LawInterfacesEnum.FZ_248;
    const isErp = getLawInterface(state) === LawInterfacesEnum.FZ_294;
    const territorialUnitsSelectOptions: ITerritorialUnitSelectOption[] = getCatalogsTerritorialUnitsSelectOptions(
      state,
    );
    const federalLawsSelectOptions: Array<IFederalLawSelectOption | IDictionarySelectOption<IFederalLawErvk>> = isErknm
      ? getFederalLaw248SelectOptions(state)
      : getKnmFederalLawsSelectOptions(state, false) || [];
    const knmTypesSelectOptionsErknm: IKnmTypeSelectOption[] = getCatalogKnmTypes248SelectOptionsSelector(state)({});
    const knmTypesSelectOptionsErp: IKnmTypeSelectOption[] = getCatalogKnmTypes294SelectOptions(state);
    const erknmOrganisationsSelectOptions:
      | IDictionaryKnoOrganizationSelectOption[]
      | undefined = getDictionariesKnoOrganizationsSelectOptions(state);
    const userKnoOrganisationsSelectOptions: IUserOrganisationSelectOption[] | undefined = getUserKnoSelectOptions(
      state,
    );
    const supervisionTypesSelectOptions: ISupervisionTypeSelectOption[] = getCatalogsSupervisionTypesSelectOptions(
      state,
    );
    const registerTypesSelectOptions: IRegisterTypeSelectOption[] = getCatalogsRegisterTypesSelectOptions(state);
    const checklistFullnessTypesSelectOptions: IChecklistFullnessTypeSelectOption[] = getCatalogsChecklistFullnessTypesSelectOptions(
      state,
    );
    const knoOrganizationAdminLevelsSelectOptions: IKnoAdminLevelSelectOption[] = getCatalogKnoAdminLevelsSelectOptions(
      state,
    );
    const userProsecutorOrganisationsSelectOptions:
      | IUserOrganisationSelectOption[]
      | undefined = getUserProsecutorSelectOptions(state);
    const knmStatusesSelectOptionsErknm: IKnmStatusSelectOption[] = getCatalogKnmStatuses248SelectOptions(state);
    const knmStatusesSelectOptionsErp: IKnmStatusSelectOption[] = getKnmErpStatusesSelectOptions(state);
    const knmSubjectTypesSelectOptions: IKnmSubjectTypeSelectOption[] = getCatalogKnmSubjectTypesSelectOptions(state);
    const knmSubjectTypesErvkSelectOptions:
      | IDictionarySelectOption<IKnmSubjectTypesERVK>[]
      | undefined = getDictionariesKnmSubjectTypesSelectOptions(state);
    const getDictionariesKnmKindsSelectOptions = makeGetDictionariesKnmKindsSelectOptions();
    const kindsSelectOptions: IDictionarySelectOption<IKnmKind>[] | undefined = getDictionariesKnmKindsSelectOptions(
      state,
      undefined,
    );
    const mspCategoriesSelectOptions: IMspCategorySelectOption[] = getCatalogsMspCategoriesSelectOptions(state);
    const responsibilityTypesSelectOptions: IResponsibilityTypeSelectOption[] = geCatalogsResponsibilityTypesSelectOptions(
      state,
    );

    const { filters } = state.knmListFilter;

    if (filters.find(f => f.meta.id === id)?.data !== undefined) {
      return;
    }

    const knmSubjectTypesCommonSelectOptions: IKnmSubjectTypeCommonSelectOption[] = [
      ...mapSubjectTypes(knmSubjectTypesSelectOptions),
      ...mapErvkSubjectTypes(knmSubjectTypesErvkSelectOptions),
    ];

    function mapSubjectTypes(items: IKnmSubjectTypeSelectOption[] | undefined): IKnmSubjectTypeCommonSelectOption[] {
      if (!Array.isArray(items)) {
        return [];
      }

      return items.map(item => ({
        id: item.id,
        name: item.name,
        code: item.code,
        title: item.name,
        label: item.label,
        value: item.code,
      }));
    }

    function mapErvkSubjectTypes(
      items: IDictionarySelectOption<IKnmSubjectTypesERVK>[] | undefined,
    ): IKnmSubjectTypeCommonSelectOption[] {
      if (!Array.isArray(items)) {
        return [];
      }

      return items
        .filter(item => item.code !== null)
        .map(item => ({
          id: item.id,
          name: item.title,
          code: item.code ?? '',
          title: item.title,
          label: item.label,
          value: item.code ?? '',
        }));
    }

    const raw: IKnmListFilterRaw = yield fetchKnmFilterById(id);
    let filter = mapRawToKnmFilter({
      raw,
      isErknm,
      territorialUnitsSelectOptions,
      federalLawsSelectOptions,
      knmTypesSelectOptions: isErknm ? knmTypesSelectOptionsErknm : knmTypesSelectOptionsErp,
      organisationsSelectOptions: isErknm
        ? erknmOrganisationsSelectOptions || []
        : userKnoOrganisationsSelectOptions || [],
      supervisionTypesSelectOptions: isErknm ? [] : supervisionTypesSelectOptions,
      registerTypesSelectOptions,
      checklistFullnessTypesSelectOptions,
      formKnoOrganizationAdminLevelsSelectOptions: [
        ...knoOrganizationAdminLevelsSelectOptions,
        noKnoOrganizationAdminLevelSelectOption,
      ],
      userProsecutorOrganisationsSelectOptions: userProsecutorOrganisationsSelectOptions ?? [],
      knmStatusesSelectOptions: isErknm ? knmStatusesSelectOptionsErknm : knmStatusesSelectOptionsErp,
      knmSubjectTypesCommonSelectOptions,
      kindsSelectOptions,
      mspCategoriesSelectOptions,
      responsibilityTypesSelectOptions,
    });

    if (isErknm || isErp) {
      const ids = convertFilterDataToControlOrganizationsIds(
        erknmOrganisationsSelectOptions,
        filter.controllingOrganizations,
      );

      const getDictionariesSupervisionTypesSelectOptions = makeGetDictionariesSupervisionTypesExtendedSelectOptions();
      let options: IDictionarySupervisionTypeSelectOption[] | undefined = getDictionariesSupervisionTypesSelectOptions(
        state,
        ids || [],
        false,
        isErp
          ? getKnmIsTypeErpPlanned(state) || !!getKnmDataPlanId(state)
          : getKnmIsTypeErknmPlanned(state) || !!getKnmDataPlanId(state),
      );

      if (ids?.length) {
        if (!options?.length) {
          options = yield dictionariesSupervisionTypesItemGetHandlerWithReturnOptions(ids);
        }

        filter = {
          ...filter,
          supervisionType: options?.find(
            (supervisionTypeSelectOption: ISupervisionTypeSelectOption | IDictionarySupervisionTypeSelectOption) =>
              supervisionTypeSelectOption?.id === raw?.supervisionTypeId,
          ),
        };
      }

      yield put(knmListFilterSetCurrentControlOrganizations(ids || []));
    }
    yield put(knmListFilterSetData(id, filter));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* knmListFilterCreateSaga(action: ActionType<typeof knmListFilterCreate>) {
  function* funcTry() {
    const { data } = action.payload;
    const state: IRootState = yield select();
    const isErknm = getLawInterface(state) === LawInterfacesEnum.FZ_248;
    const rawFilter = mapKnmFilterToRaw(data, isErknm);
    const meta: IFilterResult = yield createKnmFilter(rawFilter);
    const metaList = state.knmListFilter.filters.map(f => f.meta);

    yield put(knmListFilterSetMeta([...metaList, meta]));
    yield put(knmListFilterSetData(meta.id, data));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* knmListFilterUpdateSaga(action: ActionType<typeof knmListFilterUpdate>) {
  function* funcTry() {
    const { id, data } = action.payload;
    const lawInterface: LawInterfacesEnum = yield select(getLawInterface);
    const isErknm = lawInterface === LawInterfacesEnum.FZ_248;
    const rawFilter = mapKnmFilterToRaw(data, isErknm);

    yield updateKnmFilter(id, rawFilter);
    yield put(knmListFilterSetData(id, data));
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* knmListFilterRemoveSaga(action: ActionType<typeof knmListFilterRemove>) {
  yield sagaWrapper({
    *funcTry() {
      const { id } = action.payload;

      yield deleteKnmFilter(id);
    },
  });
}

function* knmListFilterSetCurrentControlOrganizationsSaga(
  action: ActionType<typeof knmListFilterSetCurrentControlOrganizations>,
) {
  const { ids } = action.payload;

  const federalLaws: IFederalLawErvk[] = yield select(getKnmListCurrentFederalLaws);

  yield call(knmListFilterGetSupervisionTypesSaga, ids, federalLaws);
}

function* knmListFilterSetCurrentFederalLawsSaga(action: ActionType<typeof knmListFilterSetCurrentFederalLaws>) {
  const { federalLaws } = action.payload;

  const currentControlOrganizations: string[] = yield select(getKnmListCurrentControlOrganizations);

  yield call(knmListFilterGetSupervisionTypesSaga, currentControlOrganizations, federalLaws);
}

function* knmListFilterGetSupervisionTypesSaga(currentControlOrganizations: string[], federalLaws?: IFederalLawErvk[]) {
  const federalLawUUIDs = federalLaws && federalLaws?.length ? federalLaws.map(fl => fl.id) : undefined;

  if (currentControlOrganizations.length) {
    if (!federalLaws || !federalLaws.length) {
      yield put(dictionariesSupervisionTypesItemGet(currentControlOrganizations, false));
    } else {
      yield put(dictionariesSupervisionTypesItemGet(currentControlOrganizations, false, federalLawUUIDs));
    }
  }
}
